import 'jquery';
import 'jquery-migrate';

window.jQuery.migrateMute = true;
let jQuery = window.jQuery;


// detect whether passive event handlers are supported
var supportsPassive = false;
try {
	const opts = {
		get passive() {
			// this is called when browser attempts to read "passive" property. if it does, then we know that it supports it.
			supportsPassive = true;
			return false;
		},
	};
	window.addEventListener('test',null,opts);
	window.removeEventListener('test',null,opts);
} catch( err ) {
	supportsPassive = false;
}

// if supported, then hook into jquery events and make jquery event registration use 'passive' event handlers
if( supportsPassive ) {
	if( !jQuery.hasOwnProperty('event') || !jQuery.event.hasOwnProperty('special') ) {
		jQuery.event.special = {};
	}
	var sph_types = [
		'touchstart',
		'touchmove',
		'touchend',
		'wheel',
		'mousewheel',
	];
	for( var i=sph_types.length-1; i>=0; --i ) {
		(function( type ) {
			jQuery.event.special[type] = {
				setup: function( _, ns, handle ) {
					this.addEventListener(type,handle,{passive:true});
					return true;
				},
			};
		})( sph_types[i] );
	}
}


let $ = window.$;

export {
	jQuery,
	$
};
